// React-
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const MaterialTracking = lazy(() => import('./index'));

// Material Tracking has two sub-items in the main navigation: Scan, for the line, and Manage, the tabbed screens for
// managers and supervisors. The old path opens Manage, so bookmarks and links keep working-
const MaterialTrackingRoute = () => {
    return [
        {
            key: 'material_tracking',
            path: '/material_tracking',
            component: <Navigate to="/material_tracking/manage" replace />,
        },
        {
            key: 'material_tracking/scan',
            path: '/material_tracking/scan',
            component: <MaterialTracking view="scan" />,
        },
        {
            key: 'material_tracking/manage',
            path: '/material_tracking/manage',
            component: <MaterialTracking view="manage" />,
        },
    ];
};

export default MaterialTrackingRoute;
